module.exports = __webpack_public_path__ + "static/media/thumb-icon.ee2a32da.svg";